import React from "react";
import styled, { keyframes } from "styled-components";

import { Container, Content, TopBanner, AnimatedCard, LoadingSpinner, SkeletonBar } from "../styles";
import LogoImage from "assets/images/Logo blue.png";

const epicIn = keyframes`
  0% { opacity: 0; transform: translateY(20px) scale(0.98); }
  60% { opacity: 1; transform: translateY(0) scale(1.02); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
`;

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  text-align: center;
  gap: 14px;
`;

const Title = styled.h1`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-weight: 500;
  font-size: clamp(22px, 5vw, 26px);
  margin: 0;
  color: oklch(.145 0 0);
  line-height: 1.05;
  letter-spacing: 0.5px;
  animation: ${epicIn} 800ms ease-out both;
`;

const Subtitle = styled.p`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-size: clamp(15px, 2.2vw, 18px);
  color: #374151;
  margin: 10px 0 0 0;
`;

const Logo = styled.img`
  height: 30px;
  position: absolute;
  top: 20px;
  left: 20px;
`;

const SkeletonGroup = styled.div`
  width: 100%;
  max-width: 520px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default function Loading({ themeColors, leaving = false }) {
  return (
    <Container themeColors={themeColors}>
      <TopBanner themeColors={themeColors}>
        <Logo src={LogoImage} alt="Logo" />
      </TopBanner>
      <Content>
        <AnimatedCard isFadingOut={leaving}>
          <Center role="status" aria-live="polite">
            <LoadingSpinner />
            <Title>Setting things up…</Title>
            <Subtitle>Fetching your information and loading the plan</Subtitle>
            <SkeletonGroup>
              <SkeletonBar width="80%" height="12px" />
              <SkeletonBar width="60%" height="12px" />
              <SkeletonBar width="90%" height="12px" />
            </SkeletonGroup>
          </Center>
        </AnimatedCard>
      </Content>
    </Container>
  );
}
